import moment from 'moment';
import { dateFormat_D, timeFormat, dateFormat_DD, apiDateFormat } from '../config';

export const formatDate = (date, format = dateFormat_D) => moment(date).format(format);

export const formatLongDateTime = (date) => {
	const momentDate = moment(date);
	const time = momentDate.minute() === 0 ? momentDate.format('ha') : momentDate.format(timeFormat);
	return `${momentDate.format(dateFormat_D)} at ${time}`;
};

export const getDate = (date) => moment(date, apiDateFormat).format(dateFormat_DD);

export const sortDates = (a, b) => {
	if (moment(a).isValid() && moment(b).isValid) return moment.utc(a).diff(moment.utc(b));
	return 0;
};
